import React, { Component } from "react";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";

class LinearProgressWithLabel extends Component {
  render() {
    const { value } = this.props; // expect 0–100
    return (
      <Box display="flex" alignItems="center" style={{ paddingRight: "0px" }}>
        <Box width="100%" mr={1}>
          <LinearProgress
            variant="determinate"
            value={value}
            sx={{ height: 15, borderRadius: 5 }}
          />
        </Box>
        <Box minWidth={35}>
          <Typography variant="body2" color="textSecondary">
            {`${Math.round(value)}%`}
          </Typography>
        </Box>
      </Box>
    );
  }
}
export default LinearProgressWithLabel;
